
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';
import { CalendarEventParticipant } from '@/../types/interfaces';
import { CalendarEventsApi } from '@/api/CalendarApi';
import { participantNoteOn, participantRsvpOn } from '@/helpers/availability';

@Component
export default class EventAvailabilitySummary extends Mixins(BAIconsMixin) {
	@Prop({ default: () => [] }) participants: CalendarEventParticipant[];
	@Prop({ default: 500 }) height: number;
	@Prop({ default: false }) canManage: boolean;
	@Prop({ default: null }) eventId: string | null;
	@Prop({ default: null }) calendarEventsApi: CalendarEventsApi | null;
	/** YYYY-MM-DD for one date of a repeating event; undefined summarises the whole series. */
	@Prop({ default: undefined }) occurrenceDate: string | undefined;

	reminding: boolean = false;

	/** The note that belongs to the date being viewed, not the series. */
	noteOf(participant: CalendarEventParticipant): string {
		return participantNoteOn(participant, this.occurrenceDate);
	}
	initials(name: string): string {
		if (!name) return '?';
		return name.split(' ').filter(Boolean).slice(0, 2).map(s => s[0]).join('').toUpperCase();
	}
	byRsvp(value: string): CalendarEventParticipant[] {
		return (this.participants || [])
			.filter(p => (participantRsvpOn(p, this.occurrenceDate) || 'None') === value)
			// Players first, staff after
			.sort((a, b) => Number(!!a.coachId) - Number(!!b.coachId));
	}
	get GoingList(): CalendarEventParticipant[] { return this.byRsvp('Yes'); }
	get MaybeList(): CalendarEventParticipant[] { return this.byRsvp('Maybe'); }
	get NoList(): CalendarEventParticipant[] { return this.byRsvp('No'); }
	get NoneList(): CalendarEventParticipant[] { return this.byRsvp('None'); }

	get Groups() {
		return [
			{ key: 'yes', label: 'Going', list: this.GoingList, color: 'green', icon: this.BAIcons.checkmark },
			{ key: 'maybe', label: 'Maybe', list: this.MaybeList, color: 'amber darken-2', icon: this.BAIcons.checkMaybe },
			{ key: 'no', label: 'Not Going', list: this.NoList, color: 'red', icon: this.BAIcons.close },
			{ key: 'none', label: 'No Reply', list: this.NoneList, color: 'grey', icon: this.BAIcons.account },
		];
	}
	get MailtoGoing(): string {
		const emails = this.GoingList.map(p => p.email).filter(e => !!e);
		if (emails.length === 0) return undefined;
		return `mailto:?bcc=${encodeURIComponent(emails.join(','))}`;
	}

	async remind(): Promise<void> {
		if (!this.calendarEventsApi || !this.eventId) return;
		this.reminding = true;
		try {
			const res = await this.calendarEventsApi.remindNonResponders(this.eventId, this.occurrenceDate);
			this.$emit('reminded', res);
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error('Failed to remind non-responders', e);
		} finally {
			this.reminding = false;
		}
	}
}
